export enum MagnificationTextureFilter {
  Nearest = 1003,
  Linear = 1006
}
export const MagnificationTextureFilterDescriptions: Record<MagnificationTextureFilter, string> = {
  [MagnificationTextureFilter.Nearest]: "",
  [MagnificationTextureFilter.Linear]: "",
}
